import React, { Component } from 'react';
import $ from 'jquery';
import jQuery from 'jquery';
import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import {  AddNannier, CheckCreatePartner  } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';

class verticalCommunityDetail extends Component {


    constructor(props) {
        super(props);
        this.state = {
            partyDetails: [],
            photos_arr: [],
        };
        this.id = this.props.match.params.id;
        this.type = this.props.match.params.type;
        this.getEventsInfo = this.getEventsInfo.bind(this);
        this.getEventsInfo();

    }

    componentDidMount() {
        this.getEventsInfo();
    }

    UNSAFE_componentWillMount() {

    }

    componentDidUpdate() {
    }

    async getEventsInfo() {
        let response = await FetchCall.getAdviceInfo(this.id, this.type);
        if (response) {
            const data = response.data;
            this.setState({
                partyDetails: data,
                url: data.url,
                photos_arr: data.photo_arr,
            });

        } else {
            return <div>Error</div>;
        }
    }

    gallery_image() {

        let photos = this.state.photos_arr !== undefined ? this.state.photos_arr : [];
        let rows = "";
        if (photos.length > 0) {
            rows = photos.map((photos, index) => {
                if (photos.name)
                    return (
                        <div class="col-md-4 float-left mt-4 p-0">
                            <img src={this.state.url + photos.name} alt="Img" class="img-thumbnail" />
                        </div>
                    );
            });
        } else {
            rows = "";
        }
        return rows;

    }


    render() {

        const { partyDetails } = this.state;
        console.log('partyDetails', this.state);
        let entatainer = '';
        if (this.type === 'supplier') {
            switch (partyDetails.entatainer) {
                case "1":
                    entatainer = 'Birthday party';
                    break;
                case "2":
                    entatainer = 'Dj';
                case "1,2":
                    entatainer = 'Birthday party, Dj';
                    break;
                default:
                    entatainer = partyDetails.entatainer;
            }
        }

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">{partyDetails.name} - View</h4>
                                   
                  <div class="pt-3 detailsection">
                        
                      <form className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no">
                                                {(partyDetails.category_id == 122) ?
                                                    (<div className="box-shadow-custom">
                                                        <div className="row">
                                                            <div className="form-group col-md-4">
                                                                <label>Counselor Center</label>
                                                                <p>{partyDetails.name}</p>
                                                            </div>
                                                            <div className="form-group col-md-4">
                                                                <label>Designation</label>
                                                                <p>{partyDetails.designation}</p>
                                                            </div>
                                                            <div className="form-group col-md-4">
                                                                <label>Service</label>
                                                                <p>{partyDetails.service}</p>
                                                            </div>
                                                            {/* <div className="form-group col-md-4">
                                                                <label>Sub Type</label>
                                                                <p>{partyDetails.age_grp}</p>
                                                            </div> */}
                                                        </div>
                                                    </div>) : ''}

                                                {(partyDetails.category_id == 123) ?
                                                    (<div className="box-shadow-custom">
                                                        <div className="row">
                                                            <div className="form-group col-md-4">
                                                                <label>Nannies Center</label>
                                                                <p>{partyDetails.name}</p>
                                                            </div>
                                                            <div className="form-group col-md-4">
                                                                <label>Age Group</label>
                                                                <p>{partyDetails.age_grp}</p>
                                                            </div>
                                                            <div className="form-group col-md-4">
                                                                <label>Time</label>
                                                                <p>{partyDetails.nannies_time}</p>
                                                            </div>
                                                        </div>
                                                    </div>) : ''}
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Information</span>
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <label>Email Id</label>
                                                            <p>{partyDetails.email_id}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Phone No.</label>
                                                            <p>{partyDetails.phone_number}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Website </label>
                                                            <p>{partyDetails.website}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Location</label>
                                                            <p>{partyDetails.location}</p>
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <label>Facebook</label>
                                                            <p>{partyDetails.facebook}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Twitter</label>
                                                            <p>{partyDetails.twitter}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Mode of Payment</label>
                                                            <p>{partyDetails.payment_name}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Year Established</label>
                                                            <p>{partyDetails.est_year}</p>
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <label>Website Search Keywords</label>
                                                            <p>{partyDetails.keywords}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Address</label>
                                                            <p>{partyDetails.address}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Google location Address</label>
                                                            <p>{partyDetails.google_location}</p>
                                                        </div>
                                                        {(partyDetails.vendor_id == 1 && (
                                                            <div className="form-group col-md-4">
                                                                <label>Partner Type</label>
                                                                <p>{partyDetails.partner_type == 1 ? 'Institution' : 'Individual'}</p>
                                                            </div>
                                                        ))}
                                                        <div className="form-group col-md-12">
                                                            <label>About</label>
                                                            <p>{partyDetails.about}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Images</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Banner </label>
                                                            {partyDetails.images &&
                                                                <img src={partyDetails.url + partyDetails.images} alt="Img" class="img-thumbnail" />
                                                            }
                                                        </div>



                                                        <div class="col-md-12 float-left mt-4 p-0">
                                                            <label>
                                                                Gallery Images
                                                            </label>
                                                        </div>

                                               {this.gallery_image()}
                                         </div>
                                </div>

                            </form>
               
                  </div>


                    <div class="row">
                                    <div class="col-md-12"><button class="btn btn-primary btn-sm" onClick={this.openPartnerCreate}>Create Partner</button></div>
                    </div>


            <Modal isOpen={this.state.partnercreation} size='lg' className='partnercreation-pop'>
                <ModalBody className='p-0'>
                    
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                                  <h3>Partner Creation Info</h3>
                                  <br/>
                                  <div class="form-row">
                                    <div class="form-group col-md-6">
                                      <label for="inputEmail4">Organization Name</label>
                                      <input type="text" class="form-control" id="organisation_name" name="organisation_name" placeholder="Organization Name" onChange={this.handleChange}/>
                                    </div>
                                    <div class="form-group col-md-6">
                                      <label for="inputPassword4">Username</label>
                                      <input type="text" class="form-control" id="username" name="username" placeholder="Username" onChange={this.handleChange}/>
                                    </div>
                                  </div>
                                  <div class="form-row">
                                  <div class="form-group col-md-6">
                                    <label for="inputAddress">First Name</label>
                                    <input type="text" class="form-control" id="first_name" name="first_name"  placeholder="First Name" onChange={this.handleChange}/>
                                  </div>
                                  <div class="form-group col-md-6">
                                    <label for="inputAddress2">Last Name</label>
                                    <input type="text" class="form-control" id="last_name" name="last_name" placeholder="Last Name" onChange={this.handleChange}/>
                                  </div>
                                   </div>

                                   <div class="form-row">
                                  <div class="form-group col-md-6">
                                    <label for="inputAddress">Amount Received</label>
                                    <input type="text" class="form-control" id="amountrecevied" name="amount"  placeholder="Amount" onChange={this.handleChange}/>
                                  </div>
                                  <div class="form-group col-md-6">
                                    <label for="inputAddress2">Payment Link</label>
                                    <input type="text" class="form-control" id="razorpay_payment_id" name="razorpay_payment_id" placeholder="Payment Link" onChange={this.handleChange}/>
                                  </div>
                                   </div>
                                  <div class="form-row">
                                    
                                    <div class="form-group col-md-4">
                                      <label for="inputState">Extend</label>
                                      <select id="inputState" class="form-control" name="enddate" onChange={this.handleChange}>
                                        <option selected>Choose...</option>
                                        <option value="2023-06-30">June 2023</option>
                                        <option value="2023-07-31">July 2023</option>
                                        <option value="2023-08-30">August 2023</option>
                                        <option value="2023-09-31">Sep 2023</option>
                                        <option value="2023-10-30">Oct 2023</option>
                                        <option value="2023-11-31">Nov 2023</option>
                                        <option value="2023-12-30">Dec 2023</option>
                                      </select>
                                    </div>

                                    <div class="form-group col-md-4">
                                     <label for="inputState">Plan</label>
                                      <select id="inputState" class="form-control" name="plan" onChange={this.handleChange}>
                                        <option selected>Choose...</option>
                                        <option value="3">Value Pro</option>
                                        <option value="4">Magic</option>
                                      </select>
                                   </div>
                                    
                                  </div>
                                  
                                                               

                        </Col>
                    </Row>
                    
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <button className='btn btn-sm btn-primary custome-submit' onClick={this.handleCreateSubmit}>
                                Submit
                            </button>
                            
                            <button className='btn btn-sm btn-defult custome-submit' style={{ marginLeft: '10px' }}
                                onClick={() => { this.setState({ partnercreation: false }) }}>Close</button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal >

                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default verticalCommunityDetail;


// WEBPACK FOOTER //
// ./src/components/bewise/verticalCommunityDetail.jsx